import {FormControlLabel, Radio} from "@mui/material";
import React from "react";
import {useScrollytellTranslation} from "../Admin/scrollytellContext";

export const EditAlternativeCorrectAnswer = ({checked, value, onChange, namePostfix, contrastApproved}) => {
    const tHook = useScrollytellTranslation();
    const t = typeof tHook === "function" ? tHook : (k, fb) => fb || k;

    const handleChange = event => {
        onChange("answer", event.target.value)
    }

    return (
        <FormControlLabel
            sx={{
                color: contrastApproved ? "white" : "black",
            }}
            control={
                <Radio
                    checked={checked}
                    onChange={handleChange}
                    value={value}
                    name={`quiz-${namePostfix}`}
                    inputProps={{"aria-label": value}}
                    sx={{
                        'span': {
                            color: contrastApproved ? "white" : "black",
                        }
                    }}
                />
            }
            label={t("quizCorrectAnswerLabel", "correct answer")}
        />
    )
}